module.exports = __webpack_public_path__ + "img/logo.ccae71bc.svg";